export default "__VITE_ASSET__774995db__"